import React, { useCallback, useMemo } from 'react';

import { ClientBaseDropdown } from '@/components/ClientBaseDropdown';

import { useAuthContext } from '../views/auth/Auth';
import { setStoredTenantGUIDs } from '../views/auth/tenant-storage';

export const ClientBaseSelector: React.FC = () => {
    const { availableTenants, selectedTenants, setTenants } = useAuthContext();
    const clientBases = useMemo(
        () => availableTenants.map((tenant) => ({ id: tenant.tenantGUID, name: tenant.name })),
        [availableTenants],
    );
    const selectedTenantGUIDs = useMemo(() => selectedTenants.map((tenant) => tenant.tenantGUID), [selectedTenants]);
    const handleChange = useCallback(
        (tenantGUIDs: string[]) => {
            setStoredTenantGUIDs(tenantGUIDs);
            setTenants(tenantGUIDs);
        },
        [setTenants],
    );

    return (
        <div className="mx-2.5 mb-3">
            <ClientBaseDropdown clientBases={clientBases} selected={selectedTenantGUIDs} onChange={handleChange} />
        </div>
    );
};
